import { useMemo, useState } from "react";

import { getAuthors } from "../contentful";

const promise = getAuthors();

export default function useAuthors() {
  const [authors, setAuthors] = useState([]);

  useMemo(() => {
    promise.then((authors) => {
      setAuthors(authors);
    });
  }, []);

  return authors;
}
